// extracted by mini-css-extract-plugin
export default {"messageBlock":"messageLot_messageBlock__LGAI6"};